<template>
  <div>
    <h2 class="text-base font-medium text-gray-600 mb-2">Project Assets</h2>
    <ul role="list" class="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 xl:gap-x-8">
      <li v-for="projectAsset in projectAssets" :key="projectAsset.id" class="relative">
        <ProjectAssetManagerTile :project-asset="projectAsset" :order-item-id="orderItemId" />
      </li>
    </ul>
  </div>
</template>

<script>
import ProjectAssetManagerTile from './ProjectAssetManagerTile.vue';

const STATUS_IDLE = 'STATUS_IDLE';
const STATUS_INITIALIZING = 'STATUS_INITIALIZING';
const STATUS_PENDING = 'STATUS_PENDING';
const STATUS_RESOLVED = 'STATUS_RESOLVED';
const STATUS_REJECTED = 'STATUS_REJECTED';

export default {
  components: {
    ProjectAssetManagerTile,
  },
  props: {
    projectId: {
      type: String,
      required: true,
    },
    orderItemId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      status: STATUS_IDLE,
    };
  },
  computed: {
    isStatusPending() {
      return this.status === STATUS_PENDING;
    },
    projectAssets() {
      return this.$store.getters['ui/projectProjectAssets/projectAssetsByProject'](this.projectId);
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.status = STATUS_INITIALIZING;
      this.fetchProjectAssets();
    },
    async fetchProjectAssets(params = {}) {
      try {
        await this.$store.dispatch('ui/projectProjectAssets/load', {
          projectId: this.projectId,
          params: {
            ...params,
            include: [
              'asset.assetable',
              'approvalRequestsCount',
              'approvedApprovalRequestsCount',
              'rejectedApprovalRequestsCount',
              'pendingApprovalRequestsCount',
              'pendingApprovalRequest',
            ].join(','),
          },
        });

        this.status = STATUS_RESOLVED;
      } catch (error) {
        this.status = STATUS_REJECTED;
      }
    },
    addProjectAsset(asset) {
      this.$emit('add-asset', asset);
    },
  },
};
</script>
